import apiClient from '@u/apiClient'

export default {
  checkVAT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`vat/check`, { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getCompanyInfoByVat({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`vat/company`, { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
